module.exports = __webpack_public_path__ + "static/media/upload-ig.4b5fbf3d.svg";